import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _AdquisitionItem, _LabourType } from '../../../core/services/dataBean/EntityCatalog';
import { BasicTable, MASK_MONEY, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from '../../theme/Component/hooks/useModal';
import { _ProductionResource } from '../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../theme/Component/usePaginator';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
    idProject?: any
}

export const AdquisitionProjectLinesEditor = ({ idSelector, onChange, label, returnType = "ID", render, idProject }: Props) => {

    const { instance, lista, setLista } = useDataBean(_AdquisitionItem)
    const [id, setID] = useState(null);
    const modal = useModal("PAA", MODAL_LG);
    const paginador = usePaginator();
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [paginador.page, idProject])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        console.log(selectedId)
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDAdquisitionItem == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {
        let filter = {
            IDProject: idProject
        }
        instance.getAdquisitionItemByProps(paginador.page, 15, filter).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: "IDAdquisitionItem", mask: MASK_NUMBER, visible: true },
        { title: 'Código', property: 'CodeItem' },
        { title: 'Año PAA', property: 'Year', mask: MASK_NUMBER, visible: false },
        { title: 'Necesidad', property: 'Description' },
        { title: 'Proveedor', property: 'SupplierName' },
        { title: 'Vr Contrato', property: 'ContractAmount', mask: MASK_MONEY, visible: false },
        { title: 'Rubro', property: 'IDLnBudgetIDNameList' },
        { title: 'Valor Estimado', property: 'TotalValue', mask: MASK_MONEY },
        { title: 'PI', property: 'PIValue', mask: MASK_MONEY, visible: true },
        { title: 'CC', property: 'CCValue', mask: MASK_MONEY, visible: false },
        { title: 'PF', property: 'PFValue', mask: MASK_MONEY, visible: true },
        { title: 'CDP', property: 'CDPValue', mask: MASK_MONEY, visible: false },
        { title: 'RCDP', property: 'RCDPValue', mask: MASK_MONEY, visible: false },
        { title: 'Saldo CDP', property: 'LeftValue', mask: MASK_MONEY, visible: false },
        { title: "Estado", property: "PreparationStateName" },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "ID PAA"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDAdquisitionItem); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}